import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { revalidate } from '@/services/revalidate/revalidate';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useHoslogPlansStatus = () => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation('updatePlanStatus', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: ['hoslog-plans'] });
      toast.success(res.message);
      await revalidate(['adminPlans']);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return { mutateAsync };
};

export default useHoslogPlansStatus;
